import { Component, inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AppStore } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { UdeuRecord } from 'projects/deusto-extension/src/lib/model/classes/udeu-record';
import { BoudService } from 'projects/deusto-extension/src/lib/services/boud.service';
import { BoudActionTypes } from 'projects/deusto-extension/src/lib/store/actions/boud-actions';
import { UdeuBoud } from 'projects/deusto-extension/src/lib/model/classes/udeu-boud';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'alden-boud-elements',
  templateUrl: './boud-elements.component.html',
  styleUrls: ['./boud-elements.component.scss'],
})
export class BoudRegisterComponent implements OnInit {
  @Input() record: UdeuRecord;
  @Input() group: FormGroup<any>;
  @Input() controlName: string;

  private _formBuilder = inject(FormBuilder);

  loading: boolean;

  constructor(public dialog: MatDialog, protected store: Store<AppStore>, private boudService: BoudService) { }
  
  ngOnInit(): void {
    this.loading = true;

    const bouds = this.record.bouds;
    if (bouds) {
      bouds.forEach((boud) => {
        const form = this.createForm(boud);
        this.formArray.push(form);
      });
    }

    this.loading = false;
  }

  createForm(boud?: UdeuBoud): FormGroup<any> {
    return this._formBuilder.group({
      id: [{ value: boud?.id, disabled: true }],
      name: [{ value: boud?.name, disabled: true }],
      type: [{ value: (boud?.data?.type as KeyValue<string,string>), disabled: true }],
      subtype: [{ value: (boud?.data?.subtype as KeyValue<string,string>), disabled: true }],
      primaryApprovingBody: [{ value: (boud?.data?.primaryApprovingBody as KeyValue<string,string>[]), disabled: true }],
      secondaryApprovingBody: [{ value: (boud?.data?.secondaryApprovingBody as KeyValue<string,string>[]), disabled: true }],
      secondaryApprovingBodySub: [{ value: (boud?.data?.secondaryApprovingBodySub as KeyValue<string,string>[]), disabled: true }],
      provisionNumber: [{ value: boud?.data?.provisionNumber, disabled: true }],
      actionType: [{ value: (boud?.data?.actionType as KeyValue<string,string>), disabled: true }],
      approvalDate: [{ value: boud?.data?.approvalDate, disabled: true }],
      effectiveDate: [{ value: boud?.data?.effectiveDate, disabled: true }],
    });
  }

  get formArray(): FormArray {
    return this.group.get(this.controlName) as FormArray;
  }

  formArrayGroup (index: number): FormGroup {
    return this.formArray.at(index) as FormGroup;
  }

  viewBoudElement(id: string) {
    this.boudService.openBoudDialogComponent(id, BoudActionTypes.ViewBoud, 2);
  }

}
